import "./style.css";
import { Game } from "./core/Game";
import { GardenStorage } from "./core/Storage";
import { ApiClient, CredentialStore } from "./core/ApiClient";
import { SyncManager } from "./core/SyncManager";

const LOADING_MARKUP = '<div class="loading-screen"><div class="leaf-loader">🌿</div><h1>Garden Meister</h1><p>庭の朝露を集めています…</p></div>';

function ensureRoot(): HTMLElement {
  const existing = document.querySelector<HTMLElement>("#app");
  if (existing) return existing;
  const created = document.createElement("main");
  created.id = "app";
  document.body.append(created);
  return created;
}

/**
 * 起動手順:
 *   1. localStorage から即座に読み出す（サーバーが無い/落ちていても遊べる状態を先に作る）。
 *   2. サーバーと突き合わせ、採用するセーブを決める（SyncManager.bootstrap）。
 *   3. 決まったセーブでゲームを開始する。
 * 2 はネットワーク待ちだが、ApiClient 側に打ち切り時間があるため起動が止まることはない。
 */
async function boot(): Promise<void> {
  const root = ensureRoot();
  root.innerHTML = LOADING_MARKUP;

  const storage = new GardenStorage();
  const local = storage.load();
  const api = new ApiClient();
  const credentials = new CredentialStore();

  let game: Game | null = null;
  const sync = new SyncManager(api, credentials, storage, () => {
    if (!game) throw new Error("ゲームがまだ初期化されていません。");
    return game.createSave();
  });

  const bootstrapped = await sync.bootstrap(local.data);

  root.innerHTML = "";
  game = new Game(root, bootstrapped.save, { sync, api, credentials, storage });
  game.start();
  (window as Window & { gardenMeister?: Game }).gardenMeister = game;

  if (local.error) console.warn(local.error);
  if (local.locked) game.notify("新しいバージョンのセーブデータを検出したため、保存を停止しています。ページを再読み込みしてください。", "warning");
  if (bootstrapped.notice) game.notify(bootstrapped.notice, "info");
}

if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", () => void boot(), { once: true });
else void boot();
